// ***************************
// Infinite Checkbox requires three parameters:
// 1) An array of data objects, where each object has at least a 'name' and a unique 'id' field
// 2) A boolean isLoading property, specifying whether we should render a loading spinner
// 3) a handleSelection property, a function that does something hopefully useful when a checkbox is clicked
// An optional fourth:
// 4) a showAllCheckbox property, which allows the user to disable the 'all' checkbox
// ***************************

import React from 'react';
import PropTypes from 'prop-types';
import Infinite from 'react-infinite';
import { SvgLoading } from 'sarsaparilla';
import CheckboxListItem from './CheckboxListItem';

const propTypes = {
  dataSource: PropTypes.array.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
  showAllCheckbox: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export class InfiniteCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEntrances: [],
      allSelected: false,
    };

    this.toggleCheckbox = this.toggleCheckbox.bind(this);
  }

  componentDidUpdate(_, prevState) {
    if (prevState.selectedEntrances.length !== this.state.selectedEntrances.length) {
      this.props.handleSelection(this.state.selectedEntrances);
    }
  }

  // This is where we handle the logic for displaying boxes as selected or no
  toggleCheckbox(item) {
    if (item.id === 'all') {
      if (this.state.allSelected) {
        this.setState({ selectedEntrances: [], allSelected: false });
      } else {
        this.setState((state, props) => {
          return { selectedEntrances: props.dataSource, allSelected: true };
        });
      }
    } else if (!this.state.selectedEntrances.includes(item)) {
      this.setState((state) => ({
        selectedEntrances: state.selectedEntrances.concat([item]),
      }));
    } else {
      this.setState((state) => ({
        selectedEntrances: state.selectedEntrances.filter((e) => e !== item),
        allSelected: false,
      }));
    }
  }

  generateListItems(items) {
    const checkboxes = items.map((item) => {
      // We check for properly formatted data, but don't crash the component without it
      if (item.hasOwnProperty('id') && item.hasOwnProperty('name')) {
        return (
          <CheckboxListItem
            key={item.id}
            id={item.id}
            checkboxText={item.name}
            item={item}
            isChecked={this.state.selectedEntrances.includes(item)}
            handleSelection={this.toggleCheckbox}
          />
        );
      }

      return '';
    });

    checkboxes.sort((a, b) => {
      if (a.props.item.name < b.props.item.name) return -1;
      if (a.props.item.name > b.props.item.name) return 1;
      return 0;
    });

    // We allow the component user to disable the 'all' checkbox if they aren't feeling it
    if (this.props.showAllCheckbox !== false) {
      // The 'all' checkbox is slipped into the data array here with its own special styling
      checkboxes.unshift(
        <CheckboxListItem
          key="all"
          id="all"
          checkboxText="All"
          item={{ id: 'all' }}
          handleSelection={this.toggleCheckbox}
          isChecked={this.state.allSelected}
          className="select-all-checkbox-row"
        />
      );
    }

    return checkboxes;
  }

  render() {
    const checkboxList = this.generateListItems(this.props.dataSource);

    return (
      <div className="infinite-checkbox-container">
        <React.Fragment>
          {!this.props.isLoading ? (
            <Infinite containerHeight={this.props.height} elementHeight={50} className="infinite-component-override">
              {checkboxList}
            </Infinite>
          ) : (
            <SvgLoading />
          )}
        </React.Fragment>
      </div>
    );
  }
}

InfiniteCheckbox.propTypes = propTypes;
